import { inject, NgModule } from '@angular/core';
import { ChatComponent } from './chat.component';
import { BaseModule } from '../shared/base.module';
import { ChatService } from './chat.service';
import { ChatDetailComponent } from './chat-detail/chat-detail.component';
import { CommentsAddonsModule } from "../shared/comments/comments.addons.module";
import { ChatInputComponent } from './chat-input/chat-input.component';
import { ChatUserComponent } from './chat-user/chat-user.component';
import { ChatBubbleComponent } from './chat-detail/chat-bubble/chat-bubble.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ChatResponseInterceptor } from './chat-interceptors/chat-response.interceptor';
import { WorkModule } from '../work/work.module';
import { ImageUploaderComponent } from '../shared/image-uploader/image-uploader.component';
import { ChatDocumentChipComponent } from "./chat-document-chip/chat-document-chip.component";
import { ChatEventsComponent } from './chat-events/chat-events.component';
import { ThumbnailPipe } from '../shared/pipes/thumbnail.pipe';
import { GoToCreateDirective } from '../shared/directives/go-to-create.directive';
import { DatetimePickerComponent } from '../shared/datetime-picker/datetime-picker.component';
import { BudgetFormComponent } from '../budget/form/budget-form.component';
import { ChatDocumentComponent } from './chat-document/chat-document.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';



@NgModule({
  declarations: [
    ChatComponent,
    ChatDetailComponent,
    ChatBubbleComponent,
  ],
  imports: [
    BaseModule,
    BudgetFormComponent,
    ChatDocumentComponent,
    ChatDocumentChipComponent,
    ChatEventsComponent,
    ChatInputComponent,
    ChatUserComponent,
    CommentsAddonsModule,
    DatetimePickerComponent,
    GoToCreateDirective,
    ImageUploaderComponent,
    ThumbnailPipe,
    WorkModule,
  ],
  providers: [
    ChatService,
    { provide: HTTP_INTERCEPTORS, useClass: ChatResponseInterceptor, multi: true },
  ],
  exports: [
    ChatComponent,
    ChatDetailComponent,
    ChatBubbleComponent,
    ChatEventsComponent
  ]
})
export class ChatModule {
  iconRegistry = inject(MatIconRegistry);
  sanitizer = inject(DomSanitizer);

  constructor() {
    this.iconRegistry.addSvgIcon(
      'whatsapp',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/whatsapp.svg')
    );

  }
}
